let appliedClasses = [];

export const syncBodyClass = () => {
    const main = document.querySelector('main[data-body-class]');

    if (!main) {
        return;
    }

    const next = main.dataset.bodyClass.split(' ').filter(Boolean);

    document.body.classList.remove(...appliedClasses);
    document.body.classList.add(...next);

    appliedClasses = next;
};
